import React, { FC, Fragment, useMemo, useState } from "react";
import { Item as RewardItem } from "@jnext/ts-axios-contestformat";
import { getBaseImage, getBrand, getBrandLogo, getThumbnailImage } from "../../../lib/utils/product";
import { JCMSCard, JCMSCardProps } from "../../JCMSCard";
import { RewardModal } from "../../../RewardModal";
import { CMSStaticSection } from "../../../models";
export interface JCardRewardItemProps extends RewardItem {
    cardProps?: JCMSCardProps
    quantityPerPeriod?: any;
    distributionType?: any;
}

export const JCardRewardItem: FC<JCardRewardItemProps> = ({ cardProps, quantityPerPeriod, distributionType, ...rewardItem }) => {
    const section: JCMSCardProps = useMemo(() => (
        rewardItemToSectionCard(rewardItem)
    ), [rewardItem])
    const [showModal, setShowModal] = useState<boolean>(false);

    return (
        <Fragment>
            <JCMSCard {...section} {...(cardProps || {})} onClick={() => { setShowModal(true) }} />
            {
                showModal && (
                    <RewardModal
                        quantityPerPeriod={quantityPerPeriod}
                        distributionType={distributionType}
                        onClose={() => {
                            setShowModal(false);
                        }}
                        rewardItem={rewardItem} />
                )
            }
        </Fragment>
    )
}

export function rewardItemToSectionCard(rewardItem: RewardItem) {
    const brand = getBrand(rewardItem.product);
    const _section: JCMSCardProps = {
        enabled: true,
        title: rewardItem.product?.title,
        text: brand?.title,
        type: CMSStaticSection.Types.STATIC_CARD,
        options: {
            imagePosition: 'scale-down'
        },
        sections: [
            {
                enabled: true,
                title: rewardItem.product?.title,
                text: rewardItem.product?.longDescription,
                type: CMSStaticSection.Types.STATIC_MODAL,
            }
        ]
    }

    const thumnailImage = getThumbnailImage(rewardItem.product);
    const baseImage = getBaseImage(rewardItem.product);
    const brandLogo = getBrandLogo(rewardItem.product);

    if (thumnailImage) {
        _section.image = [
            { src: thumnailImage }
        ]
    }
    if (baseImage && _section.sections?.[0]) {
        _section.sections[0].image = [
            { src: baseImage }
        ]
    }
    if (brandLogo && _section.options) {
        _section.options.contentImage = brandLogo
    }
    return _section
}
